import { TicketSubmitConfirmModal } from "@/components/Ticket/TicketSubmitConfirmModal";
import { FormItem, useTicketForm } from "./useTicketForm";

// FormFieldコンポーネント
type FormFieldProps = {
  item: FormItem;
  register: any;
  errors: any;
  options?: FormItem["attribute_options"];
  getValidationRules: (columnName: string) => any;
};

const FormField = ({
  item,
  register,
  errors,
  options,
  getValidationRules,
}: FormFieldProps) => {
  const fieldOptions = options || item.attribute_options;

  return (
    <tr key={item.id}>
      <th className="label">
        {item.name}
        <span className="error">※</span>
      </th>
      <td className="content">
        {fieldOptions.length > 0 ? (
          fieldOptions.map((opt) => (
            <label key={opt.code} className="inline-label">
              <input
                type="radio"
                value={opt.code}
                {...register(
                  item.column_name,
                  getValidationRules(item.column_name)
                )}
              />
              {opt.option}
            </label>
          ))
        ) : item.column_name === "inquiry_detail" ? (
          <textarea
            rows={5}
            className="uk-width-1-1"
            {...register(
              item.column_name,
              getValidationRules(item.column_name)
            )}
          />
        ) : (
          <input
            type="text"
            className="uk-width-1-1"
            {...register(
              item.column_name,
              getValidationRules(item.column_name)
            )}
          />
        )}
        {errors[item.column_name] && (
          <div className="error">
            {errors[item.column_name]?.message as string}
          </div>
        )}
      </td>
    </tr>
  );
};

export function TicketInput() {
  const {
    fileInputRef,
    register,
    errors,
    formInputs,
    modalMessage,
    inquiryType1,
    inquiryType2,
    isType1Other,
    filteredType2Options,
    otherFormItems,
    handleConfirmButtonClick,
    handleConfirmSubmit,
    handleCancelSubmit,
    getValidationRules,
  } = useTicketForm();

  if (!formInputs) return <div className="ticket-input-container"></div>;

  return (
    <div className="ticket-input-container">
      <h3 className="title">▼問合せ内容</h3>
      <div className="precaution">※は必須です</div>
      <div className="ticket-input-tbl_wrap mb-40">
        <form>
          <table className="ticket-input-tbl uk-width-1-1">
            <tbody>
              {inquiryType1 && (
                <FormField
                  item={inquiryType1}
                  register={register}
                  errors={errors}
                  getValidationRules={getValidationRules}
                />
              )}
              {inquiryType2 && !isType1Other && (
                <FormField
                  item={inquiryType2}
                  register={register}
                  errors={errors}
                  options={filteredType2Options}
                  getValidationRules={getValidationRules}
                />
              )}
              {otherFormItems.map((item) => (
                <FormField
                  key={item.id}
                  item={item}
                  register={register}
                  errors={errors}
                  getValidationRules={getValidationRules}
                />
              ))}
              <tr>
                <th className="label">ファイル添付</th>
                <td className="content">
                  <input
                    type="file"
                    ref={fileInputRef}
                    multiple
                    className="file-input"
                  />
                  <span>
                    複数ファイル選択可能：合計容量は10MBまでとなります。
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
      <div className="submit-button-section">
        <button
          type="button"
          className="uk-button--l uk-button-refer"
          onClick={handleConfirmButtonClick}
        >
          送信
        </button>
      </div>

      {modalMessage?.emailPreviewData && (
        <TicketSubmitConfirmModal
          isShow={!!modalMessage.emailPreviewData}
          onConfirm={handleConfirmSubmit}
          onCancel={handleCancelSubmit}
          emailPreviewData={modalMessage.emailPreviewData}
        />
      )}
    </div>
  );
}
